// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/data/jenkins/workspace/exam-platform-front@2/src/models/enum';
import model_2 from '/data/jenkins/workspace/exam-platform-front@2/src/models/learningPfEnum';

export const models = {
model_1: { namespace: 'enum', model: model_1 },
model_2: { namespace: 'learningPfEnum', model: model_2 },
} as const
